const trimSecondsFromTimeFormat = (timeFormat) => timeFormat.replace(/[^0-9]ss?/, '');

const getFormatAliases = (formats) => ({
  ymd: formats.fullDate,
  his: formats.fullTime,
  mmd: formats.dayAndMonth,
  mmm: formats.monthFullName,
  mm: formats.monthShortName,
  ymdhis: formats.fullDateWithFullTime,
  ymdhi: formats.fullDateWithHoursAndMins,
  date: formats.fullDate,
  datetime: formats.fullDateWithHoursAndMins,
  time: formats.hoursAndMins
});

export const getFormatsForConfig = ({ dateFormat, timeFormat }) => ({
  year: 'yyyy',
  month: 'MM',
  monthFullName: 'MMMM',
  monthShortName: 'MMM',
  day: 'dd',
  dayFullName: 'EEEE',
  dayShortName: 'EEEEEE',
  hours: 'HH',
  mins: 'mm',
  secs: 'ss',
  fullDate: dateFormat,
  fullTime: timeFormat,
  fullDateWithFullTime: `${dateFormat} ${timeFormat}`,
  fullDateWithHoursAndMins: `${dateFormat} ${trimSecondsFromTimeFormat(timeFormat)}`,
  monthAndYear: 'MMM yyyy',
  dayAndMonth: 'dd. MMM',
  hoursAndMins: trimSecondsFromTimeFormat(timeFormat)
});

export const getFormatsWithAliasesForConfig = (formatConfig) => {
  const formats = getFormatsForConfig(formatConfig);

  return { ...formats, ...getFormatAliases(formats) };
};

const defaultDateFormat = 'yyyy-MM-dd';
const defaultTimeFormat = 'HH:mm:ss';
const defaultPhpDateFormat = 'Y-m-d';
const defaultPhpTimeFormat = 'H:i:s';

export const defaultFormatConfig = {
  dateFormat: defaultDateFormat,
  timeFormat: defaultTimeFormat
};

export const defaultPhpFormatConfig = {
  dateFormat: defaultPhpDateFormat,
  timeFormat: defaultPhpTimeFormat
};
